export var notificationManagerPortalTokens = {
  notificationItemMode: "colored",
  itemGap: 8,
  marginTop: 16,
  marginBottom: 32,
  marginLeft: 16,
  marginRight: 16,
  snackMaxWidth: 360
};